import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Card, Table, Loader, Button, Popup, Icon} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {paths} from '../../../../common/dictionaries/urls';
import {statusDictionary} from '../../../constants';
import {Actions} from '../../../../common/actions';

class ErrorCodes extends Component {
  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.WarrantyErrorCodes,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }

    this.props.fetchWarrantyErrorCodesList();
  }

  renderLoaderOrCodes = () => {
    const {loading, list} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan="100%">
            <Loader active inline="centered" content="Ejecutando" />
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!list.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign="center" colSpan={13}>
            No hay datos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }

    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign="center">{element.code}</Table.Cell>
          <Table.Cell textAlign="center">{element.description}</Table.Cell>
          <Table.Cell textAlign="center">
            {statusDictionary[element.status]}
          </Table.Cell>
          <Table.Cell textAlign="center">
            <Popup
              trigger={
                <Link to={`/codigos-error-de-garantias/editar/${element.code}`}>
                  <Icon name="write" color="red" size="large" />
                </Link>
              }
              content="Editar"
              position="top center"
              inverted
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  };

  render() {
    return (
      <div className="warranty-container">
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>Códigos Error de Garantías</h2>
              <div className="title-bar-actions">
                <Button
                  primary
                  className="toyota-primary"
                  as={Link}
                  to={paths.WarrantyErrorCodesNew}
                >
                  Añadir nuevo
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid className="error-codes-warranty-table">
          <Table striped className="toyota-grid">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center">Código</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">
                  Descripción
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Estado</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Acciones</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.renderLoaderOrCodes()}</Table.Body>
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'list': state.warrantyErrorCodes.list,
    'loading': state.warrantyErrorCodes.loading,
  };
};

const {
  fetchWarrantyErrorCodesList,
  navigateTo,
} = Actions;

const mapDispatchToProps = {
  fetchWarrantyErrorCodesList,
  navigateTo,
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorCodes);
